import React from 'react';
import styled from 'styled-components';

import { AnchorText, Col, Container, Grid, Section } from '../../common';

const StyledSection = styled((props) => <Section {...props} />)`
  background-color: ${(props) => props.$bgColor};
  & span {
    color: ${(props) => props.$spanColor};
  }
`;

const StyledTagline = styled.span`
  color: ${(props) => props.$spanColor};
`;

const HtmlSitemapDefault = (props) => {
  const { sanity, page } = props;
  const { business, colors, pages } = sanity;
  const { gbp } = page;

  return (
    <StyledSection
      padding="custom"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.darker}
      h3Color={colors?.primary?.dark}
      $spanColor={colors?.accent?.light}
      classes="pt-[10rem] lg:pt-[15rem] pb-24"
    >
      <Container
        initialOpacity={1}
        initialScale={1}
        padding="none"
        classes="max-w-md px-4 text-center sm:max-w-3xl lg:max-w-4xl"
      >
        <StyledTagline
          $spanColor={colors?.accent?.dark}
          className="text-base font-semibold tracking-wider uppercase"
        >
          {business?.name}
        </StyledTagline>
        <h1 className="mx-auto text-3xl font-extrabold tracking-tight sm:text-4xl lg:max-w-4xl">
          <span className="lg:text-5xl">Our Sitemap</span>
        </h1>
        {/* <Container
        initialOpacity={1}
        initialScale={1}
        padding="sm"
        classes="pt-24"
      > */}
        <Grid classes="pt-16 lg:pt-20 lg:grid-cols-2 gap-8 lg:gap-8 text-left">
          <Col padding="1rem" classes="space-y-6 bg-white rounded-xl shadow-xl">
            <h3>Company</h3>
            <ul className="space-y-3 lg:space-y-2">
              {pages.filter((page) => page?.type === 'brand').length ? (
                pages
                  .filter((page) => page?.type === 'brand')
                  .map((page) => (
                    <li>
                      <AnchorText
                        sanity={sanity}
                        type="internal"
                        to={page?.slug?.current}
                      >
                        {page?.name}
                      </AnchorText>
                    </li>
                  ))
              ) : (
                <li className="italic">No Pages</li>
              )}
            </ul>
          </Col>
          <Col padding="1rem" classes="space-y-6 bg-white rounded-xl shadow-xl">
            <h3>Services</h3>
            <ul className="space-y-3 lg:space-y-2">
              {pages.filter((page) => page?.type === 'service').length ? (
                pages
                  .filter((page) => page?.type === 'service')
                  .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''))
                  .map((page) => (
                    <li key={page?.slug?.current}>
                      <AnchorText
                        sanity={sanity}
                        type="internal"
                        to={page?.slug?.current}
                      >
                        {page?.name}
                      </AnchorText>
                    </li>
                  ))
              ) : (
                <li className="italic">No Pages</li>
              )}
            </ul>
          </Col>
          <Col padding="1rem" classes="space-y-6 bg-white rounded-xl shadow-xl">
            <h3>Locations</h3>
            <ul className="space-y-3 lg:space-y-2">
              {pages.filter((page) => page?.type === 'location').length ? (
                pages
                  .filter((page) => page?.type === 'location')
                  .map((page) => (
                    <li>
                      <AnchorText
                        sanity={sanity}
                        type="internal"
                        to={page?.cityStateSlug}
                      >
                        {page?.cityStateZip}
                      </AnchorText>
                    </li>
                  ))
              ) : (
                <li className="italic">No Pages</li>
              )}
            </ul>
          </Col>
          <Col padding="1rem" classes="space-y-6 bg-white rounded-xl shadow-xl">
            <h3>Blog Posts</h3>
            <ul className="space-y-3 lg:space-y-2">
              {pages.filter((page) => page?.type === 'post').length ? (
                pages
                  .filter((page) => page?.type === 'post')
                  .map((page) => (
                    <li>
                      <AnchorText
                        sanity={sanity}
                        type="internal"
                        to={page?.slug?.current}
                      >
                        {page?.name}
                      </AnchorText>
                    </li>
                  ))
              ) : (
                <li className="italic">No Pages</li>
              )}
            </ul>
          </Col>
        </Grid>
      </Container>
      {/* </Container> */}
    </StyledSection>
  );
};

export { HtmlSitemapDefault };
